import { ChipIcon } from '../components/ChipIcon.js';

export function Balance() {
  return (
    <div className="mx-auto flex w-full max-w-[420px] flex-col gap-4 px-5 py-6 text-sm text-ivory/85">
      <h1 className="heading-display text-3xl">Баланс и фишки</h1>
      <p className="text-xs text-ivory/55">Как покупать, тратить и выводить</p>

      <Section title="Что такое фишки">
        <p className="flex items-center gap-1 flex-wrap">
          Фишка <ChipIcon size={14} /> — это <strong>внутренняя валюта</strong> durakapp.
          Ставки в партиях, банк, выигрыши — всё в фишках. Ты держишь их в Профиле и тратишь
          на столах.
        </p>
        <p>
          Это <strong>не Telegram Stars</strong>. Stars — это <em>один из</em> способов купить
          фишки. Можно так же платить USDT, TON, BTC, ETH через @CryptoBot или напрямую TON
          с любого кошелька. Все каналы зачисляют фишки на один и тот же баланс.
        </p>
        <p>
          Каждый платёж защищён от двойного списания — учитывается ровно один раз.
        </p>
      </Section>

      <Section title="Курсы и реальная цена 1 фишки">
        <p>Сколько фишек получишь за единицу валюты — и сколько эта фишка стоит в рублях:</p>
        <table className="w-full text-xs" style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid color-mix(in oklab, var(--color-gold) 30%, transparent)' }}>
              <th className="py-1.5 text-left text-ivory/55 font-normal uppercase tracking-wider">Платишь</th>
              <th className="py-1.5 text-right text-ivory/55 font-normal uppercase tracking-wider">Фишек</th>
              <th className="py-1.5 text-right text-ivory/55 font-normal uppercase tracking-wider">₽/фишка</th>
            </tr>
          </thead>
          <tbody style={{ fontFamily: 'var(--font-display)' }}>
            <Row asset="1 ⭐ Telegram Star" chips="1" perChip="≈ 1.8 ₽" highlight />
            <Row asset="1 USDT" chips="85" perChip="≈ 1.0 ₽" />
            <Row asset="1 TON" chips="450" perChip="≈ 1.0 ₽" />
            <Row asset="1 BTC" chips="8 500 000" perChip="≈ 1.0 ₽" />
            <Row asset="1 ETH" chips="280 000" perChip="≈ 1.0 ₽" />
          </tbody>
        </table>
        <p className="text-xs text-ivory/55">
          <strong>Stars-канал дороже</strong> — Telegram продаёт пользователю 100 ⭐ за 180 ₽
          в TG-store, но из-за комиссии Telegram нам приходит существенно меньше. Поэтому за
          1 ⭐ мы даём 1 фишку, а не 1.8. Это плата за удобство «оплаты в один тап в Telegram».
          Если хочешь дешевле — плати через CryptoBot или TON, где 1 фишка стоит примерно 1 ₽.
        </p>
        <p className="text-xs text-ivory/55">
          На вывод действует тот же курс плюс 5% спред — он покрывает on-chain комиссии и
          краткосрочные колебания цены крипты.
        </p>
      </Section>

      <Section title="Как покупать фишки">
        <p>Профиль → <strong>Пополнить</strong>. Открывается лист с тремя вкладками:</p>
        <ul className="ml-4 list-disc space-y-1">
          <li>
            <strong>Telegram Stars</strong> — платишь Stars из своего TG-кошелька.
            За 1 ⭐ даём 1 фишку (один к одному).
          </li>
          <li>
            <strong>CryptoBot</strong> — платишь USDT, TON, BTC, ETH или другой криптой
            через @CryptoBot. За 1 USDT даём 85 фишек, за 1 TON — 450, и т.д. (см. таблицу
            ниже).
          </li>
          <li>
            <strong>TON</strong> — отправляешь TON напрямую с любого кошелька (Tonkeeper,
            TG-Wallet, ваш холодник). 1 TON = 450 фишек.
          </li>
        </ul>
        <p className="text-xs text-ivory/55">
          После оплаты фишки появляются на балансе автоматически — за 1-3 секунды (Stars),
          ~30 секунд (CryptoBot) или 1-2 минуты (TON, после подтверждения сети).
        </p>
      </Section>

      <Section title="Как фишки тратятся в игре">
        <ul className="ml-4 list-disc space-y-1">
          <li>
            При входе в очередь на стол со ставкой <strong>списываем</strong> ставку с баланса.
          </li>
          <li>
            Если матч не состоялся (отменили поиск, дисконнект до старта) — ставка{' '}
            <strong>возвращается автоматически</strong>.
          </li>
          <li>
            После партии: проигравший теряет ставку, остальные делят банк поровну.
            Платформа удерживает <strong>10% комиссии</strong> с банка.
          </li>
          <li>
            Ничья — каждому возвращается его ставка без комиссии.
          </li>
        </ul>
      </Section>

      <Section title="Способы вывода">
        <p>Профиль → <strong>Вывести</strong> открывает два канала:</p>
        <ul className="ml-4 list-disc space-y-1">
          <li>
            <strong>Через @CryptoBot</strong> — фишки конвертируются в USDT/TON/BTC/ETH и
            попадают в твой CryptoBot-аккаунт; оттуда вывод на любой кошелёк или биржу.
            Минимум — 50 фишек.
          </li>
          <li>
            <strong>Прямой TON</strong> — указываешь свой TON-адрес, мы шлём TON через
            свой кошелёк. Подтверждение сети 1-2 минуты. Минимум — 200 фишек.
          </li>
        </ul>
        <p className="text-xs text-ivory/55">
          Курс с депозита и вывода — одинаковый, плюс ~5% спред в нашу сторону. Спред
          покрывает on-chain комиссии и краткосрочные колебания цены.
        </p>
      </Section>

      <Section title="Шаги для вывода через CryptoBot">
        <Steps
          items={[
            'Открой /profile → «Вывести» → таб «В @CryptoBot».',
            'Выбери актив (USDT / TON / BTC / ETH) и сумму фишек. Минимум — 50.',
            'Подтверди. Мы списываем фишки и сразу отправляем перевод в @CryptoBot.',
            'В @CryptoBot откроется уведомление, оттуда — «Вывести» на свой внешний кошелёк или биржу.',
          ]}
        />
      </Section>

      <Section title="Шаги для прямого TON">
        <Steps
          items={[
            'Депозит: «Пополнить» → таб «TON» → введи сумму TON → «Получить адрес».',
            'Открой свой TON-кошелёк (Tonkeeper, TG-Wallet, любой) → отправь TON на полученный адрес С КОММЕНТАРИЕМ (без него индексер не сматчит).',
            'Через 1-2 минуты после Confirmed фишки появятся на балансе.',
            'Вывод: «Вывести» → «На TON-адрес» → впиши свой TON-адрес и сумму фишек → подтверди.',
          ]}
        />
        <p className="text-xs text-ivory/55">
          Минимум на вывод TON — 200 фишек (~0.5 TON), потому что TON gas-комиссия сама ~0.01
          TON, и мелкие суммы не имеют смысла.
        </p>
      </Section>

      <Section title="Возврат депозита Telegram Stars">
        <p>
          Если пополнял через Telegram Stars и хочешь вернуть конкретный платёж назад в
          TG-кошелёк — напиши в поддержку{' '}
          <a href="https://t.me/durakapp_game_bot" className="text-gold underline" target="_blank" rel="noreferrer">
            @durakapp_game_bot
          </a>{' '}
          в течение <strong>21 дня</strong> после оплаты. Это Telegram-механизм{' '}
          <code>refundStarPayment</code> — он работает только для конкретного charge_id и только
          если на балансе достаточно неистраченных фишек с этого пополнения.
        </p>
        <p className="text-xs text-ivory/55">
          Telegram Bot API не даёт прямой перевод Stars от бота к пользователю — поэтому для
          вывода выигрышей используются CryptoBot и TON каналы.
        </p>
      </Section>

      <Section title="Спорные ситуации">
        <p>
          Каждая партия записывается детерминированно (seed + полный лог ходов), каждая
          транзакция — в журнал с уникальным внешним id. По спорам пиши в{' '}
          <a href="https://t.me/durakapp_game_bot" className="text-gold underline" target="_blank" rel="noreferrer">
            @durakapp_game_bot
          </a>{' '}
          в течение 7 дней с момента события.
        </p>
      </Section>

      <Section title="Налоги и юридический статус">
        <p>
          Подкидной дурак — игра на навык, не азарт; durakapp оперирует внутриигровыми
          фишками, а не фиатной валютой. Налоговая трактовка зависит от твоей юрисдикции
          — консультируйся с локальным юристом, если планируешь крупные обороты.
        </p>
      </Section>
    </div>
  );
}

function Row({
  asset,
  chips,
  perChip,
  highlight,
}: {
  asset: string;
  chips: string;
  perChip: string;
  highlight?: boolean;
}) {
  const color = highlight ? 'var(--color-coral)' : 'var(--color-ivory)';
  return (
    <tr style={{ borderBottom: '1px solid color-mix(in oklab, var(--color-gold) 12%, transparent)' }}>
      <td className="py-1.5 text-left text-ivory/85" style={{ fontSize: 13 }}>{asset}</td>
      <td className="py-1.5 text-right" style={{ color, fontSize: 14 }}>{chips}</td>
      <td className="py-1.5 text-right" style={{ color, fontSize: 13 }}>{perChip}</td>
    </tr>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="flex flex-col gap-2">
      <h2 className="heading-display text-xl text-gold">{title}</h2>
      {children}
    </section>
  );
}

function Steps({ items }: { items: string[] }) {
  return (
    <ol className="flex flex-col gap-2">
      {items.map((step, i) => (
        <li
          key={i}
          className="flex items-start gap-3 rounded-2xl px-3 py-2.5"
          style={{
            background: 'var(--color-glass)',
            border: '1px solid color-mix(in oklab, var(--color-gold) 22%, transparent)',
          }}
        >
          <span
            className="grid h-6 w-6 shrink-0 place-items-center rounded-full"
            style={{
              background: 'var(--color-gold)',
              color: 'var(--color-felt-deep)',
              fontFamily: 'var(--font-display)',
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            {i + 1}
          </span>
          <span>{step}</span>
        </li>
      ))}
    </ol>
  );
}
